"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _APReactSelect = require("../../common/APReactSelect/APReactSelect");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _priceGroupingHelper = require("../../../helpers/orderBook/priceGroupingHelper");
require("./PriceGroupingSelector.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('price-grouping-selector');

// Order Book re-renders on every websocket price tick, but this selector's own
// props only change on user interaction - memoized so an open menu isn't torn
// down mid-interaction by unrelated parent re-renders.
var PriceGroupingSelector = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    options = _ref.options;
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;

  // Both an unset and a "None" grouping resolve to an explicit null, which is what surfaces
  // the "Group by..." placeholder. The selection has to be handed over as an option object
  // rather than a string: the value-as-string path resolves an unmatched value to `undefined`,
  // and react-select's state manager reads an undefined `value` as uncontrolled and goes on
  // rendering its own last internal selection.
  var selectedOption = (0, _react.useMemo)(function () {
    return value && value !== _priceGroupingHelper.NONE_GROUPING_VALUE ? options.find(function (option) {
      return option.value === value;
    }) || null : null;
  }, [value, options]);
  var handleChange = (0, _react.useCallback)(function (option) {
    return onChange(option ? option.value : _priceGroupingHelper.NONE_GROUPING_VALUE);
  }, [onChange]);
  var input = (0, _react.useMemo)(function () {
    return {
      value: selectedOption,
      onChange: handleChange,
      onBlur: function onBlur() {}
    };
  }, [selectedOption, handleChange]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses()
  }, /*#__PURE__*/_react["default"].createElement(_APReactSelect.InnerReactSelect, {
    input: input,
    options: options,
    isSearchable: false,
    isClearable: false,
    placeholder: t('Group by...'),
    customClass: baseClasses('select'),
    "aria-label": t('Price Grouping')
  }));
});
PriceGroupingSelector.displayName = 'PriceGroupingSelector';
PriceGroupingSelector.propTypes = {
  value: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired
  })).isRequired
};
var _default = exports["default"] = PriceGroupingSelector;